// export this package's api
import QueueAnim from './QueueAnim';

export default QueueAnim;


//////////////////
// WEBPACK FOOTER
// ../~/rc-queue-anim/es/index.js
// module id = 445
// module chunks = 1